export { default as StockPageTitle } from "./StockPageTitle"
